import { debounce } from "ts-debounce";
export const detectTypingStopped = (node, debounceTime = 500) => {
    const handleKeyup = debounce((event) => {
        if (node.contains(event.target)) {
            node.dispatchEvent(new CustomEvent('typingStopped'));
        }
    }, debounceTime);
    document.addEventListener('keyup', handleKeyup, true);
    return {
        destroy: () => {
            document.removeEventListener('keyup', handleKeyup, true);
        },
        update: (newDebounceTime) => {
            debounceTime = newDebounceTime;
        },
    };
};
